import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function SparkleFilled({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 12 12"
    >
      <Path
        d="M11.8289 1.64196C11.1375 1.40676 10.5931 0.862328 10.3579 0.170899C10.3121 0.0365127 10.1822 -0.000244141 10.1047 -0.000244141C10.0273 -0.000244141 9.89734 0.0365129 9.85163 0.170899C9.61642 0.862328 9.07199 1.40676 8.38057 1.64196C8.24618 1.68767 8.20942 1.81763 8.20942 1.89508C8.20942 1.97252 8.24618 2.10248 8.38057 2.14819C9.07199 2.3834 9.61642 2.92783 9.85163 3.61925C9.89734 3.75364 10.0273 3.7904 10.1047 3.7904C10.1822 3.7904 10.3121 3.75364 10.3579 3.61925C10.5931 2.92783 11.1375 2.3834 11.8289 2.14819C11.9633 2.10248 12.0001 1.97252 12.0001 1.89508C12.0001 1.81763 11.9633 1.68767 11.8289 1.64196Z"
        fill={iconColor}
      />
      <Path
        d="M5.96849 1.44859C5.89793 1.16782 5.64597 1.06284 5.46846 1.06284C5.29094 1.06284 5.03899 1.16782 4.96842 1.44859C4.402 3.70248 2.63964 5.46484 0.38575 6.03127C0.104981 6.10183 0 6.35378 0 6.5313C0 6.70882 0.104983 6.96077 0.385751 7.03133C2.63964 7.59776 4.402 9.36011 4.96843 11.614C5.03899 11.8948 5.29094 11.9998 5.46846 11.9998C5.64598 11.9998 5.89793 11.8948 5.96849 11.614C6.53492 9.36011 8.29727 7.59776 10.5512 7.03133C10.8319 6.96077 10.9369 6.70881 10.9369 6.5313C10.9369 6.35378 10.8319 6.10183 10.5512 6.03127C8.29727 5.46484 6.53492 3.70248 5.96849 1.44859Z"
        fill={iconColor}
      />
    </Svg>
  );
}
